const normalizeValue = value => String(value || '').trim().toLowerCase();

const collectEntrySignatures = entries => {
  const labels = new Set();
  const paths = new Set();

  entries.forEach(entry => {
    if (!entry) return;
    if (entry.type === 'section') {
      labels.add(normalizeValue(entry.label));
      if (Array.isArray(entry.items)) {
        entry.items.forEach(item => {
          labels.add(normalizeValue(item.label));
          paths.add(normalizeValue(item.to));
        });
      }
      return;
    }

    labels.add(normalizeValue(entry.label));
    paths.add(normalizeValue(entry.to));
  });

  return { labels, paths };
};

const cloneEntries = entries =>
  entries.map(entry => {
    if (entry?.type === 'section') {
      return { ...entry, items: entry.items ? entry.items.map(item => ({ ...item })) : [] };
    }
    return entry ? { ...entry } : entry;
  });

const appendUniqueItems = (items, signature) => {
  const nextItems = [];
  items.forEach(item => {
    const labelKey = normalizeValue(item?.label);
    const pathKey = normalizeValue(item?.to);
    if (!labelKey || !pathKey) return;
    if (signature.labels.has(labelKey) || signature.paths.has(pathKey)) {
      return;
    }
    signature.labels.add(labelKey);
    signature.paths.add(pathKey);
    nextItems.push(item);
  });
  return nextItems;
};

export function mergeMenus(menuBaseData, clipperAdmin) {
  const merged = Object.entries(menuBaseData || {}).reduce((acc, [moduleKey, entries]) => {
    acc[moduleKey] = cloneEntries(entries || []);
    return acc;
  }, {});

  Object.entries(clipperAdmin || {}).forEach(([moduleKey, entries]) => {
    if (!merged[moduleKey]) {
      merged[moduleKey] = cloneEntries(entries || []);
      return;
    }

    const moduleEntries = merged[moduleKey];
    const signature = collectEntrySignatures(moduleEntries);

    entries.forEach(entry => {
      if (!entry) return;
      if (entry.type === 'section') {
        const sectionLabelKey = normalizeValue(entry.label);
        const existingSection = moduleEntries.find(
          item => item.type === 'section' && normalizeValue(item.label) === sectionLabelKey,
        );

        const nextItems = appendUniqueItems(entry.items || [], signature);

        if (!nextItems.length) {
          return;
        }

        if (existingSection) {
          existingSection.items = [...(existingSection.items || []), ...nextItems];
          return;
        }

        moduleEntries.push({ ...entry, items: nextItems });
        return;
      }

      const labelKey = normalizeValue(entry.label);
      const pathKey = normalizeValue(entry.to);
      if (!labelKey || !pathKey) return;
      if (signature.labels.has(labelKey) || signature.paths.has(pathKey)) {
        return;
      }
      signature.labels.add(labelKey);
      signature.paths.add(pathKey);
      moduleEntries.push({ ...entry });
    });
  });

  return merged;
}
